<script>
    import objectStore from "./../store.js";
    import { checkInput, handleLogin, handleForgot } from "./../common.js";
    import { onMount, createEventDispatcher } from "svelte";

    import Registration from "./Registration.svelte";
    import Image from "./Image.svelte";
    export let api;
    export let token;

    let isMobile = false;

    // Se activa en el navegador
    onMount(() => {
        isMobile = window.innerWidth <= 768;
        window.addEventListener("resize", () => {
            isMobile = window.innerWidth <= 768;
        });
    });

    let showLogin = true;
    const dispatch = createEventDispatcher();

    let confirmPassword;
    let passConBlur = false;

    $: passConVal =
        confirmPassword &&
        password &&
        password.length >= 6 &&
        password === confirmPassword;

    function changeForm() {
        showLogin = !showLogin;
    }

    function toLogin() {
        dispatch("tologin", {
            register: false,
        });
    }

    function handleOverlayClick() {
        dispatch("back"); // App.svelte lo maneja con on:back
    }

    let email;
    let password;
    let forgot = false;
    let result = false;
    let submitted = false;

    $: emailVal = email && email.match(/[^\s@]+@[^\s@]+\.[^\s@]+/);
    $: passVal = forgot || (password && password.length >= 6);
    $: good = emailVal && passVal;

    let emailBlur = false;
    let passBlur = false;

    function handleForgotChange() {
        if (forgot) {
            forgot = false;
            document.getElementById("check-email").style.visibility = "hidden";
        } else {
            forgot = true;
        }
    }

    function changeForgotlOGIN() {
        forgot = !forgot;
        showLogin = true;
    }

    function handleSubmit() {
        console.log("login forgot" + forgot);

        if (forgot) {
            handleForgot(
                api,
                "Domains/UserForgot",
                email,
                submitted,
                result,
                token,
            );
        } else {
            handleLogin(
                api,
                "Domains/UserLogin",
                $objectStore,
                email,
                password,
                submitted,
                result,
                token,
            );
        }
    }
</script>

{#if isMobile}
    <!-- Bottom Sheet para móviles -->
    <div id="overlay" on:click={handleOverlayClick}>
        <div id="login" on:click|stopPropagation>
            <div class="image-container">
                <Image />
            </div>

            <form on:submit|preventDefault={handleSubmit}>
                <input type="text" placeholder="Email" bind:value={email} />
                {#if showLogin}
                    <input
                        type="password"
                        placeholder="Password"
                        bind:value={password}
                    />
                    <div id="forgot" on:click={() => (forgot = !forgot)}>
                        Forgot?
                    </div>
                {:else}
                    <input
                        type="password"
                        placeholder="Password"
                        bind:value={password}
                    />
                    <input
                        type="password"
                        placeholder="Confirm Password"
                        bind:value={confirmPassword}
                    />
                {/if}

                <button
                    type="submit"
                    class="btn-svelte {good ? 'good' : 'disabled'}"
                >
                    {#if forgot}
                        Forgot Password
                    {:else if showLogin}
                        Submit
                    {:else}
                        Register
                    {/if}
                </button>

                <div id="forgot2" on:click={changeForm}>
                    {#if showLogin}
                        Need an account? Register
                    {:else}
                        Have an account? Login
                    {/if}
                </div>
            </form>
        </div>
    </div>
{:else}
    <!-- Modal centrado para PC -->
    <div id="overlay" on:click={handleOverlayClick}>
        <div class="modal-pc" on:click|stopPropagation>
            <div class="image-container">
                <Image />
            </div>

            <form on:submit|preventDefault={handleSubmit}>
                <input type="text" placeholder="Email" bind:value={email} />
                {#if showLogin}
                    <input
                        type="password"
                        placeholder="Password"
                        bind:value={password}
                    />
                    <div id="forgot" on:click={() => (forgot = !forgot)}>
                        Forgot?
                    </div>
                {:else}
                    <input
                        type="password"
                        placeholder="Password"
                        bind:value={password}
                    />
                    <input
                        type="password"
                        placeholder="Confirm Password"
                        bind:value={confirmPassword}
                    />
                {/if}

                <button
                    type="submit"
                    class="btn-svelte {good ? 'good' : 'disabled'}"
                >
                    {#if forgot}
                        Forgot Password
                    {:else if showLogin}
                        Submit
                    {:else}
                        Register
                    {/if}
                </button>

                <div id="forgot2" on:click={changeForm}>
                    {#if showLogin}
                        Need an account? Register
                    {:else}
                        Have an account? Login
                    {/if}
                </div>
            </form>
        </div>
    </div>
{/if}

<style>
    #overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
    }

    #login {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: clamp(320px, 90%, 480px);
        max-height: 80vh;
        background: white;
        border-radius: 30px 30px 0 0;
        box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.2);
        padding: 30px 20px 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        animation: slide-up 0.4s ease-out;
        overflow-y: auto;
    }

    .modal-pc {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: clamp(320px, 90%, 480px);
        background: white;
        border-radius: 20px;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
        padding: 40px 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    form {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    input {
        width: 100%;
        padding: 12px;
        border-radius: 10px;
        border: 1px solid #ccc;
    }

    button {
        margin-top: 20px;
        padding: 12px;
        border-radius: 10px;
        border: none;
        background: black;
        color: white;
        cursor: pointer;
    }

    .btn-svelte.disabled {
        opacity: 0.5;
        pointer-events: none;
    }

    #forgot,
    #forgot2 {
        color: black;
        font-size: 14px;
        text-align: center;
        cursor: pointer;
    }

    .image-container {
        margin-bottom: 20px;
        display: flex;
        justify-content: center;
    }

    @keyframes slide-up {
        from {
            transform: translateY(100%);
        }
        to {
            transform: translateY(0);
        }
    }
</style>
